/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import RefundedbagQueryResult from './RefundedbagQueryResult';

/**
 * The RefundedbagOutputCmsRecord model module.
 * @module model/RefundedbagOutputCmsRecord
 * @version 1.0
 */
class RefundedbagOutputCmsRecord {
    /**
     * Constructs a new <code>RefundedbagOutputCmsRecord</code>.
     * @alias module:model/RefundedbagOutputCmsRecord
     */
    constructor() { 
        
        RefundedbagOutputCmsRecord.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RefundedbagOutputCmsRecord</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RefundedbagOutputCmsRecord} obj Optional instance to populate.
     * @return {module:model/RefundedbagOutputCmsRecord} The populated <code>RefundedbagOutputCmsRecord</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RefundedbagOutputCmsRecord();

            if (data.hasOwnProperty('record')) {
                obj['record'] = RefundedbagQueryResult.constructFromObject(data['record']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/RefundedbagQueryResult} record
 */
RefundedbagOutputCmsRecord.prototype['record'] = undefined;






export default RefundedbagOutputCmsRecord;

